import React, { useId, useState } from 'react';
import Icon from '../../components/Icon';

export default function AuthField({
  label,
  icon,
  type = 'text',
  value,
  onChange,
  placeholder,
  autoComplete,
  required = false,
  maxLength,
  hint,
}) {
  const id = useId();
  const [revealed, setRevealed] = useState(false);
  const isPassword = type === 'password';
  const inputType = isPassword && revealed ? 'text' : type;

  return (
    <div className="field">
      <label className="field-label" htmlFor={id}>
        {label}
        {!required && <span style={{ color: 'var(--text-faint)', fontWeight: 500 }}> · optional</span>}
      </label>
      <div className="field-input-wrap">
        {icon && (
          <span className="field-icon">
            <Icon name={icon} size={17} />
          </span>
        )}
        <input
          id={id}
          className={`input${icon ? ' input-with-icon' : ''}${isPassword ? ' input-with-action' : ''}`}
          type={inputType}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          autoComplete={autoComplete}
          required={required}
          maxLength={maxLength}
        />
        {isPassword && (
          <button
            type="button"
            className="field-action"
            onClick={() => setRevealed((v) => !v)}
            aria-label={revealed ? 'Hide password' : 'Show password'}
          >
            <Icon name={revealed ? 'eyeOff' : 'eye'} size={17} />
          </button>
        )}
      </div>
      {hint && <div className="field-hint">{hint}</div>}
    </div>
  );
}
